import React from 'react';
import styled from 'styled-components';
import { media } from 'theme';

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 114px;
  width: 100%;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.seedlyBlue};
  padding: 17px 12px;

  background-color: ${props =>
    !props.desktopBackground && props.theme.colors.seedlyBlue};
  background-image: ${props =>
    props.desktopBackground && `url(${props.desktopBackground})`};
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;

  ${media.largeAndDown`
    height: 130px;
  `}
`;

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  >*: nth-child(n + 1) {
    margin-right: 8px;
    margin-bottom: 8px;
  }

  ${media.largeAndDown`
    padding-left: 15px;
    padding-right: 7px;
  `}
`;

const Title = styled.p`
  font-size: 18px;
  color: white;
  font-weight: bold;
  margin-bottom: 8px;

  ${media.largeAndDown`
    font-size: 16px;
  `}
`;

const LinkContainer = styled.a`
  width: 310px;

  ${media.largeAndDown`
    width: calc((100% / 2) - 10px);
  `}
`;

const TotalProduct = styled.p`
  font-size: 14px;
  color: white;
`;

const CategoryCard = ({ name, desktopBackground, productCount }) => {
  return (
    <CardContainer desktopBackground={desktopBackground}>
      <Title>Best {name} in Singapore</Title>
      <TotalProduct>{productCount} products</TotalProduct>
    </CardContainer>
  );
};

const SearchCategoryCardList = props => {
  const { categories } = props;

  return (
    <ListContainer>
      {categories.map(category => {
        const { id, name, desktopBackground, slug, productCount } = category;
        const url = `/reviews/${slug}`;
        return (
          <LinkContainer
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            key={id}
          >
            <CategoryCard
              name={name}
              productCount={productCount}
              desktopBackground={desktopBackground}
            />
          </LinkContainer>
        );
      })}
    </ListContainer>
  );
};

export default SearchCategoryCardList;
